<!-- 智能图文消息管理 -->
<template>
  <div>
    <!-- 标题 -->
    <div class="page-title">智能图文消息管理</div>

    <div
      style="
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin: 10px 0 0;
      "
    >
      <div style="font-size: 16px; font-weight: 600">
        {{ gzh_name }}（ID:{{ gzh_id }}）
      </div>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 10px 0 20px;
      "
    >
      <div>已设置消息（共 {{ table_total }} 条）</div>
      <a-button @click="addMsgHandle" type="primary" icon="plus"
        >添加消息</a-button
      >
    </div>

    <div>
      <div v-for="(item, index) in itemData" :key="index" class="item-box">
        <!-- <div class="item-box-title">公众号：{{item.gzh_name}}</div> -->
        <div
          class="item-box-title"
          style="display: flex; justify-content: space-between"
        >
          <div style="display: flex; justify-content: space-between">
            <span v-if="item.delay_type === 2">
              {{ item.delay_text }}
            </span>
            <div v-else>
              <span v-if="item.show_time_control == 1"
                >关注后 {{ item.show_minute }} 分钟</span
              >
              <span v-else-if="item.show_time_control == 2"
                >关注后 {{ item.show_hour }} 小时
                <span v-if="item.show_minute">{{ item.show_minute }} 分钟</span>
              </span>
              <a-tag  color="blue"  style="text-align: center; padding: 0 12px;margin-left:4px;">{{ type_map[item.material.draft_type] || "" }}</a-tag>
            </div>

            <a-tag
              v-if="item.material && item.material.deleted_at"
              color="red"
              style="margin-left: 7px"
              >已删除</a-tag
            >
          </div>

          <a-switch
            size="small"
            :checked="item.switch_status"
            @change="switchChange($event, item)"
          />
        </div>
        <div style="position: relative">
          <img
            class="item-top-img"
            style=""
            :src="
              item.material &&
              item.material.url &&
              item.material.url[0].local_thumb_url
            "
            alt=""
          />
          <div class="item-top-title" style="">
            {{
              (item.material &&
                item.material.url &&
                item.material.url[0].title) ||
              "空"
            }}
          </div>
        </div>

        <div
          v-for="(item_z, index_z) in item.material && item.material.url"
          :key="index_z"
        >
          <div v-if="index_z > 0" class="item-cell-box">
            <div style="flex: 1">{{ item_z.title }}</div>
            <img class="item-cell-img" :src="item_z.local_thumb_url" alt="" />
          </div>
        </div>

        <div class="item-button-box" style="">
          <!-- <div @click="handleButton(2,item)" class="handle-button" style="margin-right: 20px;margin-bottom: 7px;">手机预览</div> -->
          <div
            @click="handleButton(3, item)"
            class="handle-button"
            style="margin-right: 20px; margin-bottom: 7px"
          >
            编辑
          </div>
          <div
            @click="handleButton(4, item)"
            class="handle-button"
            style="margin-right: 20px; margin-bottom: 7px"
          >
            删除
          </div>
        </div>
      </div>
      <div
        v-show="itemData.length == 0"
        style="text-align: center; text-align: center; padding: 80px 0 50px"
      >
        <a-icon style="font-size: 70px; color: #999" type="file-search" />
        <div style="color: #999; font-size: 16px; margin-top: 20px">
          内容为空
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div
      style="text-align: center; margin-top: 30px; position: sticky; left: 30px"
    >
      <a-pagination
        v-model="r_page"
        :pageSize="r_limit"
        :total="table_total"
        :showTotal="(total, range) => `共 ${total} 条`"
        @change="paginationChange"
        show-quick-jumper
      />
    </div>

    <a-drawer
      :title="`${drawer_title}消息`"
      width="1400px"
      placement="right"
      :closable="false"
      :visible="visibleMsg"
      @close="drawerClose"
    >
      <div style="height: 100%; display: flex">
        <div
          style="width: 320px; border-right: 1px solid #ccc; min-height: 80vh"
        >
          <div style="font-size: 16px; margin-bottom: 15px">推送时机</div>
          <a-radio-group v-model="delay_type" class="radio-group">
            <a-radio :value="1">用户关注后N分钟</a-radio>
            <a-radio :value="2">用户关注后第N天定时</a-radio>
          </a-radio-group>

          <div
            style="display: inline-block; align-items: center"
            v-if="delay_type === 1"
          >
            <span>用户关注后</span>
            <a-input-number
              :min="0"
              v-model="imgText_hour"
              style="width: 70px; margin: 0 5px"
            />
            <span>小时</span>
            <a-input-number
              :min="0"
              v-model="imgText_minute"
              style="width: 70px; margin: 0 5px"
            />
            <span>分钟</span>
          </div>
          <div
            style="display: inline-block; align-items: center"
            v-if="delay_type === 2"
          >
            <span>用户关注后第</span>
            <a-input-number
              :min="0"
              v-model="imgText_day"
              style="width: 70px; margin: 0 5px"
            />
            <span style="margin: 0 5px">天</span>
            <a-time-picker
              style="width: 120px"
              v-model="imgText_curTime"
              format="HH:mm"
            />
          </div>

          <div style="font-size: 16px; margin-bottom: 10px; margin-top: 41px">
            推送图文
          </div>
          <div style="min-height: 200px; position: relative">
            <div
              v-if="setImgText.content && setImgText.content.length > 0"
              class="item-box"
              style="margin-right: 0"
            >
              <div style="position: relative">
                <img
                  class="item-top-img"
                  style=""
                  :src="setImgText.content[0].local_thumb_url"
                  alt=""
                />
                <div class="item-top-title" style="">
                  {{ setImgText.content[0].title || "空" }}
                </div>
              </div>

              <div
                v-for="(item_z, index_z) in setImgText.content"
                :key="index_z"
              >
                <div v-if="index_z > 0" class="item-cell-box">
                  <div style="flex: 1">{{ item_z.title }}</div>
                  <img
                    class="item-cell-img"
                    :src="item_z.local_thumb_url"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div
              v-else
              style="
                position: absolute;
                top: 40%;
                left: 50%;
                transform: translate(-50%, -50%);
              "
            >
              请设置智能图文
            </div>
          </div>

          <div style="display: flex; align-items: center">
            <div style="font-size: 16px; margin-right: 20px">开启状态</div>
            <a-switch
              size="small"
              :checked="imgText_switch"
              @change="switchImgText($event, item)"
            />
          </div>

          <div class="form-cell-box" style="margin-top: 30px">
            <a-button
              @click="drawerRequest"
              :loading="drafts_button_loading"
              type="primary"
              style="margin-right: 20px"
              >确认</a-button
            >
            <a-button @click="drawerClose">取消</a-button>
          </div>
        </div>

        <div style="padding: 0 0 0 25px; flex: 1; position: relative">
          <div style="font-size: 16px; margin-bottom: 15px">草稿箱</div>

          <div style="display: flex; align-items: center; margin-bottom: 15px">
            <div
              @click="syncWxDraft"
              style="display: flex; align-items: center; cursor: pointer"
            >
              <a-icon
                style="color: #62a8ea; font-size: 16px"
                type="cloud-download"
              />
              <div style="color: #62a8ea; margin-left: 10px">
                同步微信草稿箱
              </div>
            </div>

            <div
              @click="RefreshButton"
              style="
                display: flex;
                align-items: center;
                cursor: pointer;
                margin-left: 30px;
              "
            >
              <a-icon :spin="sync_true" style="color: #62a8ea" type="sync" />
              <div style="color: #62a8ea; margin-left: 10px">刷新</div>
            </div>
          </div>

          <div>
            <div
              v-for="(item, index) in draftsData"
              :key="index"
              class="item-box"
            >
              <!-- <div class="item-box-title">公众号：{{item.gzh_name}}</div> -->
              <div style="position: relative">
                <img
                  class="item-top-img"
                  style=""
                  :src="item.content[0].local_thumb_url"
                  alt=""
                />
                <div class="item-top-title" style="">
                  {{ item.content[0].title || "空" }}
                </div>
              </div>

              <div v-for="(item_z, index_z) in item.content" :key="index_z">
                <div v-if="index_z > 0" class="item-cell-box">
                  <div style="flex: 1">{{ item_z.title }}</div>
                  <img
                    class="item-cell-img"
                    :src="item_z.local_thumb_url"
                    alt=""
                  />
                </div>
              </div>

              <div class="item-button-box" style="">
                <div
                  @click="handleDrawer(2, item)"
                  class="handle-button"
                  style="margin-right: 20px; margin-bottom: 7px"
                >
                  手机预览
                </div>
                <div
                  @click="handleDrawer(3, item)"
                  class="handle-button"
                  style="margin-right: 20px; margin-bottom: 7px"
                >
                  设为智能图文
                </div>
              </div>
            </div>
          </div>
          <!-- 分页 -->
          <div
            style="
              text-align: center;
              margin-top: 30px;
              position: sticky;
              left: 30px;
            "
          >
            <a-pagination
              v-model="s_page"
              :pageSize="s_limit"
              :total="drafts_total"
              :showTotal="(total, range) => `共 ${total} 条`"
              @change="draftsPaginationChange"
              show-quick-jumper
            />
          </div>

          <!-- 加载中 -->
          <div
            style="
              position: absolute;
              left: 50%;
              top: 40%;
              transform: translate(-50%, -50%);
            "
            v-show="drafts_search_loading"
          >
            <a-spin size="large" />
          </div>
        </div>
      </div>
    </a-drawer>

    <a-modal
      title="预览"
      :visible="preview_visible"
      :confirm-loading="preview_confirmLoading"
      @ok="previewOk"
      @cancel="previewCancel"
      width="700px"
    >
      <div>
        <div class="form-cell-box">
          <div class="class-title">微信号</div>
          <a-input
            v-model="s_wechat_id"
            placeholder="请输入微信号"
            style="width: 330px"
          />
        </div>
        <div class="form-cell-box">
          <div class="class-title"></div>
          <div>提示：该微信需要首先关注公众号：{{ gzh_name }}</div>
        </div>
        <div class="form-cell-box">
          <div class="class-title"></div>
          <img
            v-if="preview_code_url"
            :src="preview_code_url"
            style="width: 180px; vertical-align: text-top"
          />
        </div>
      </div>
    </a-modal>

    <!-- 加载中 -->
    <div class="loading-box" v-show="search_button_loading">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import "moment/locale/zh-cn";
import {
  imgtxtMsgList,
  imgtxtMsgEdit,
  imgtxtMsgDel,
  wxMaterialDraft,
  wxMaterialDraftSync,
  imgtxtMsgAdd,
  wxGetGzhCode,
  wxMaterialPreview,
} from "@/request/api";
export default {
  name: "imgTextMessage_",
  components: {},
  data() {
    return {
      type_map: {
        1: `H5`,
        2: `小程序`,
        0: `未知`,
      },
      gzh_id: "",
      gzh_name: "",

      itemData: [], // 内容

      r_page: 1, // 页数
      r_limit: 20, // 每页多少条
      table_total: 0, // 总数

      search_button_loading: false,

      // 新增编辑侧边栏
      visibleMsg: false,
      drawer_title: "添加",
      s_page: 1,
      s_limit: 6,
      drafts_total: 0,

      sync_true: false, // 刷新的icon是否旋转
      sync_true_control: true, // 刷新的节流控制
      drafts_search_loading: false, // 草稿箱内容的加载状态

      draftsData: [], // 草稿箱数据
      drafts_button_loading: false,
      setImgText: {
        content: [],
      }, // 设置的
      imgText_minute: 0,
      imgText_hour: 0,
      imgText_day: 0,
      imgText_curTime: null,
      delay_type: 1,
      imgText_switch: false, // 配置开关

      // 预览弹窗
      preview_visible: false,
      preview_confirmLoading: false,
      s_wechat_id: "", // 微信号
      title_gzh_name: "全部", // 选中的公众号名字
      preview_code_url: "", // 预览弹窗要展示的 公众号二维码

      edit_id: null, // 编辑用的id

      s_id: null, // 手机预览时用的素材id
    };
  },
  mounted() {
    let that = this;
    console.log("$route", this.$route.query);
    // 接收从计划页面传过来的参数
    if (this.$route.query) {
      this.gzh_id = this.$route.query.j_gzh_id;
      this.gzh_name = this.$route.query.j_gzh_name;
    }

    that.searchButton();
  },
  methods: {
    searchButton() {
      let that = this;
      that.search_button_loading = true;

      imgtxtMsgList({
        gzh_id: this.gzh_id,
        order: "delay_time",
        sort: "asc",
      })
        .then((res) => {
          console.log("---", res);
          that.search_button_loading = false;
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            let data = res.data.data.data;
            data.forEach((res) => {
              if (res.status == 1) {
                res.switch_status = true;
              } else {
                res.switch_status = false;
              }

              if (res.delay_type === 2) {
                let imgText_hour = Math.floor(res.delay_time / 60);
                let imgText_minute = res.delay_time - imgText_hour * 60;
                let curHour = String(imgText_hour).padStart(2, "0");
                let curMinute = String(imgText_minute).padStart(2, "0");
                if (res.delay_day) {
                  res.delay_text = `用户关注后第${res.delay_day}天${curHour}:${curMinute}`;
                } else {
                  res.delay_text = `用户关注当天${curHour}:${curMinute}`;
                }
              }

              // 关注后x小时
              if (res.delay_time < 60) {
                res.show_time_control = 1; // 表示显示分钟
                res.show_minute = res.delay_time;
              } else {
                res.show_time_control = 2; // 表示显示小时
                res.show_hour = Math.floor(res.delay_time / 60);
                res.show_minute = res.delay_time - res.show_hour * 60;
              }
            });
            that.itemData = res.data.data.data;
            console.log("itemData", that.itemData);
            that.table_total = res.data.data.total;
          } else {
            if (res.data.code == 401) {
              // 未登录
              localStorage.removeItem("access_token");
              that.$router.replace({
                name: "login",
                params: { type: "not_log" },
              });
            } else {
              that.$message.error(`错误：${res.data.msg}`);
            }
          }
        })
        .catch(() => {
          that.search_button_loading = false;
          that.$message.error(`网络错误`);
        });

      setTimeout(() => {
        that.search_button_loading = false;
      }, 5000);
    },
    // 开关
    switchChange(e, item) {
      const status = item.status === 0 ? 1 : 0;
      let that = this;
      imgtxtMsgEdit({
        id: item.id,
        status,
      }).then((res) => {
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          item.switch_status = e;
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },

    // 分页
    paginationChange(e) {
      this.r_page = e;
      this.searchButton();
    },

    // 操作
    handleButton(e, item) {
      console.log("操作item", item);
      let that = this;
      if (e == 3) {
        this.drawer_title = "编辑";
        this.edit_id = item.id;
        this.setImgText = {
          id: item.material && item.material.id,
          content: item.material && item.material.url,
        };

        if (item.status == 1) {
          this.imgText_switch = true;
        } else {
          this.imgText_switch = false;
        }

        this.imgText_hour = Math.floor(item.delay_time / 60);
        this.imgText_minute = item.delay_time - this.imgText_hour * 60;
        this.imgText_day = item.delay_day;
        this.delay_type = item.delay_type || 1;

        if (item.delay_type === 2) {
          //编辑回显处理;
          let curHour = String(this.imgText_hour).padStart(2, "0");
          let curMinute = String(this.imgText_minute).padStart(2, "0");
          let curDate = moment().format("YYYY-MM-DD");
          this.imgText_curTime = `${curDate} ${curHour}:${curMinute}:00`;
        }

        if (this.draftsData.length > 0) {
          this.visibleMsg = true;
        } else {
          this.s_page = 1;
          this.wxSyncSearch();
        }
      } else if (e == 4) {
        // 删除

        this.$confirm({
          title: "确定要删除吗?",
          content: `删除后不可恢复`,
          okText: "删除",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            imgtxtMsgDel({
              id: item.id,
            }).then((res) => {
              console.log("删除", res);
              if (res.data.code == 0) {
                that.$message.success("删除成功");
                that.searchButton();
              } else {
                if (res.data.code === 401) {
                  // 未登录
                  localStorage.removeItem("access_token");
                  that.$router.replace({
                    name: "login",
                    params: { type: "not_log" },
                  });
                } else {
                  that.$message.error(`错误：${res.data.msg}`);
                }
              }
            });
          },
          onCancel() {
            console.log("Cancel");
          },
        });
      }
    },

    // 添加消息
    addMsgHandle() {
      this.drawer_title = "添加";

      if (this.draftsData.length > 0) {
        this.visibleMsg = true;
      } else {
        this.s_page = 1;
        this.wxSyncSearch();
      }
    },

    // 手动微信同步草稿箱
    syncWxDraft() {
      let that = this;

      this.search_button_loading = true;
      wxMaterialDraftSync({
        id: this.gzh_id,
      })
        .then((res) => {
          that.search_button_loading = false;
          console.log("手动微信同步草稿箱", res);
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            that.$message.success(res.data.msg);
          } else {
            if (res.data.code == 401) {
              // 未登录
              localStorage.removeItem("access_token");
              that.$router.replace({
                name: "login",
                params: { type: "not_log" },
              });
            } else {
              that.$message.error(`错误：${res.data.msg}`);
            }
          }
        })
        .catch(() => {
          that.search_button_loading = false;
          that.$message.error(`网络错误`);
        });
    },
    wxSyncSearch(type) {
      let that = this;
      that.drafts_search_loading = true;
      let r_data = {
        page: that.s_page, // 页数
        limit: that.s_limit, // 每页多少条
        gzh_id: that.gzh_id, // 公众号ID
        is_send: 0, // 0表示微信草稿箱的列表，1表示已发布的草稿箱列表
      };
      wxMaterialDraft(r_data).then((res) => {
        console.log("获取列表", res.data.data);
        that.drafts_search_loading = false;
        if (type == "refresh") {
          that.sync_true = false;
          that.s_page = 1;
        }
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.draftsData = res.data.data.data;

          that.drafts_total = res.data.data.total;

          that.visibleMsg = true;
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },
    // 刷新
    RefreshButton() {
      this.sync_true = true;
      this.wxSyncSearch("refresh");
    },
    draftsPaginationChange(e) {
      this.s_page = e;
      this.wxSyncSearch();
    },

    // 侧边栏草稿的操作
    handleDrawer(e, item) {
      console.log("item", item);
      if (e == 2) {
        // 手机预览
        this.s_id = item.id;
        this.search_button_loading = true;
        wxGetGzhCode({
          id: this.gzh_id,
        })
          .then((res) => {
            this.search_button_loading = false;
            console.log("获取公众号二维码", res);
            this.preview_code_url = res.data.data.info.qr_code || "";
            this.preview_visible = true;
          })
          .catch(() => {
            this.search_button_loading = false;
            this.$message.error(`网络错误`);
          });
      } else if (e == 3) {
        // 设为智能图文
        this.setImgText = item;
      }
    },
    // 侧边栏-确认按钮
    drawerRequest() {
      let that = this;

      let delay_time = that.imgText_hour * 60 + that.imgText_minute;
      const delay_day = this.delay_type === 2 ? this.imgText_day : 0;

      if (this.delay_type === 2) {
        if (!this.imgText_curTime) {
          this.$message.warning("请选择时间");
          return;
        }
        let imgText_curTime = "";

        if (this.imgText_curTime._d) {
          imgText_curTime = moment(this.imgText_curTime._d).format("HH:mm:ss");
        } else {
          imgText_curTime = this.imgText_curTime.slice(11);
        }

        let timeArr = imgText_curTime.split(":");
        delay_time = Number(timeArr[0]) * 60 + Number(timeArr[1]);
      } else if (this.imgText_hour == 0 && this.imgText_minute < 5) {
        this.$message.warning("推送时间最少设置5分钟");
        return;
      }
      if (this.setImgText.content && this.setImgText.content.length > 0) {
        this.drafts_button_loading = true;
        if (this.drawer_title == "添加") {
          let r_data = {
            gzh_id: that.gzh_id,
            material_id: that.setImgText.id,
            delay_time: delay_time,
            status: that.imgText_switch ? 1 : 0, // 配置开关0=关闭，1=开启
            delay_type: this.delay_type,
            delay_day: delay_day,
          };
          imgtxtMsgAdd(r_data).then((res) => {
            console.log("侧边栏-确认按钮", res);
            that.drafts_button_loading = false;
            if (res.data.code == 0 || res.data.code == 200) {
              that.$message.success("操作成功");
              that.drawerClose();
              that.searchButton();
            } else {
              if (res.data.code == 401) {
                // 未登录
                localStorage.removeItem("access_token");
                that.$router.replace({
                  name: "login",
                  params: { type: "not_log" },
                });
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }
          });
        } else if (this.drawer_title == "编辑") {
          imgtxtMsgEdit({
            id: that.edit_id,
            material_id: that.setImgText.id,
            delay_time: delay_time,
            status: that.imgText_switch ? 1 : 0, // 配置开关0=关闭，1=开启
            delay_type: this.delay_type,
            delay_day: delay_day,
          }).then((res) => {
            // console.log('编辑',res)
            that.drafts_button_loading = false;
            if (
              res.data.code == 0 ||
              res.data.code == 200 ||
              res.data.code == 8011
            ) {
              that.$message.success("编辑成功");
              that.drawerClose();
              that.searchButton();
            } else {
              if (res.data.code == 401) {
                // 未登录
                localStorage.removeItem("access_token");
                that.$router.replace({
                  name: "login",
                  params: { type: "not_log" },
                });
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }
          });
        }
      } else {
        this.$message.warning("未设置智能图文");
      }
    },
    drawerClose() {
      (this.setImgText = {
        content: [],
      }),
        (this.visibleMsg = false);
    },
    switchImgText(e) {
      this.imgText_switch = e;
    },

    // 预览弹窗
    previewOk() {
      let that = this;
      that.preview_confirmLoading = true;
      wxMaterialPreview({
        id: this.s_id,
        wechat_id: this.s_wechat_id,
      }).then((res) => {
        console.log("预览弹窗", res);
        that.preview_confirmLoading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          that.$message.success(res.data.msg);
          that.previewCancel();
        } else {
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },
    previewCancel() {
      this.s_wechat_id = "";
      this.preview_visible = false;
    },
  },
};
</script>

<style scoped>
.item-box {
  position: relative;
  width: 300px;
  padding: 25px;
  /* border: 1px solid #ccc; */
  display: inline-block;
  margin: 0 30px 20px 0;
  border-radius: 12px;
  vertical-align: top;
  background-color: #fff;
  box-shadow: 0 0 5px 3px #eee;
}
.item-box-title {
  font-size: 14px;
  margin-bottom: 18px;
}
.item-top-img {
  width: 100%;
  height: 150px;
}
.item-top-title {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 5px;
}
.item-cell-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e8e8e8;
  padding: 10px 0;
}
.item-cell-img {
  width: 70px;
  height: 70px;
}
.item-button-box {
  display: flex;
  flex-wrap: wrap;
  margin-top: 15px;
}

.handle-button {
  /* display: flex;
	align-items: center;
	justify-content: center;
	height: 24px; */

  padding: 2px 9px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 4px;
  font-size: 13px;
  color: #40a9ff;

  border: 1px solid #40a9ff;
  cursor: pointer;
}
.handle-button:hover {
  background-color: #40a9ff;
  color: #fff;
}

.radio-group {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
</style>
